import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import config from 'config/api';
import i18n from 'helpers/i18n';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import clsx from 'clsx';
// import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import Header from 'components/Header/Header';
// import Banner from 'components/Banner/Banner';
import AccountSettingsForm from 'components/UI/Account/AccountSettingsForm';
import AccountDeleteForm from 'components/UI/Account/AccountDeleteForm';
import Input from 'components/UI/Form/Input';
import Typography from '@material-ui/core/Typography';
import { isLoggedIn, getCurrentUser } from 'components/UI/Account/ducks/authentication';
import { fetchData, getDataHome } from 'ducks/asyncFetcher';
import isMember from 'helpers/isMember';
// import Container from '@material-ui/core/Container';
// import Grid from '@material-ui/core/Grid';
// import Fade from '@material-ui/core/Fade';
// import Footer from '../Footer';
import Template from 'components/UI/Template/Template';
const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      minHeight: '100%',
      width: '100%'
    },
    pageTitle: {
      paddingTop: 16,
    },
    paperWrapper: {
      width: '100%',
      display: 'block',
      position: 'relative',
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        content: "' '",
        height: '160px',
        backgroundColor: theme.palette.primary.light,
        zIndex: -1
      }
    },
    paper: {
      padding: theme.spacing(4),
      paddingTop: 0,
      maxWidth: 1280,
      marginLeft: 'auto',
      marginRight: 'auto',
      // backgroundColor: 'transparent',
    },
  };
};

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // tabSelected: 0
      showPasswordForm: false,
      passwordComplete: false,
    };
    this._onSubscriptionComplete = this._onSubscriptionComplete.bind(this);
    this._onClose = this._onClose.bind(this);
  }

  componentDidMount() {
    this.props.onMount();
  }

  _onSubscriptionComplete() {
    this.props.onMount();
  }
  _onClose() {
    const { history } = this.props;
    history.push('/');
  }
  _onShowChangePassForm = () => {
    this.setState({showPasswordForm: true})
  }
  _onHideChangePassForm = () => {
    this.setState({showPasswordForm: false})
  }
  _onPasswordComplete = () => {
    this.setState({passwordComplete: true})
  }

  render() {
    // const { onPanelToggle, classes, userRole, isLoggedIn, $$data } = this.props;
    const { classes, isLoggedIn, $$data, $$user } = this.props;
    const { showPasswordForm, passwordComplete } = this.state;

    if (!isLoggedIn) {
      return (
        <Redirect
          to={{
            pathname: '/',
            state: { from: this.props.location },
          }}
          />
      );
    }

    return (
      <Template>
        <Box className={clsx(classes.paperWrapper)}>
          <Typography variant="h1" className={classes.pageTitle}>
            {i18n.get('accountFormTitle')}
          </Typography>{' '}
          <Paper square elevation={0} className={classes.paper}>
            <Paper square elevation={0} className={classes.paper}>
              <Choose>
                <When condition={isLoggedIn && $$data !== undefined && showPasswordForm === true}>
                  <AccountSettingsForm onFormCancel={this._onHideChangePassForm} onFormComplete={this._onPasswordComplete}/>
                    <If condition={passwordComplete === true}>
                      <Box mt={2} width="100%" align="center">
                        <Button variant="contained" color="primary" onClick={this._onHideChangePassForm}>{i18n.get('commonBack', {pretty: false})}</Button>
                      </Box>
                    </If>

                </When>
                <Otherwise>
                  <If condition={isLoggedIn && $$data !== undefined && isMember($$user, 'member')}>
                    <Box mb={4}>
                      <Typography variant="h6">{i18n.get('accountYourAccount', {pretty: false})}</Typography>
                    </Box>
                    <Grid container spacing={4}>
                      {/*<Grid item xs={12}>
                        <Input name="job" value={$$user.get('job')} label={i18n.get('accountJob', {pretty: false})} variant="outlined" disabled={true}/>
                      </Grid>*/}
                      <Grid item xs={6}>
                        <Input name="firstname" value={$$user.get('firstname')} label={i18n.get('accountFirstname', {pretty: false})} variant="outlined" disabled={true}/>
                      </Grid>
                      <Grid item xs={6}>
                        <Input name="lastname" value={$$user.get('lastname')} label={i18n.get('accountLastname', {pretty: false})} variant="outlined" disabled={true}/>
                      </Grid>
                      <Grid item xs={12}>
                        <Input name="email" value={$$user.get('email')} label={i18n.get('accountEmail', {pretty: false})} variant="outlined" disabled={true}/>
                      </Grid>
                      <Grid item xs={12}>
                        <Box align="center" width="100%">
                          <Button variant="contained" color="primary" onClick={this._onShowChangePassForm}>{i18n.get('accountChangePassBt', {pretty: false})}</Button>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <Box align="center" width="100%">
                          <AccountDeleteForm onFormCancel={this._onClose} />
                        </Box>
                      </Grid>
                    </Grid>
                  </If>
                </Otherwise>
              </Choose>
            </Paper>
          </Paper>
        </Box>
      </Template>
    );
  }
}
function mapStateToProps(state) {
  const props = {
    $$user: getCurrentUser(state),
    $$data: getDataHome(state),
    isLoggedIn: isLoggedIn(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Account)));



// WEBPACK FOOTER //
// ./src/components/Account/Account.jsx